<template>
  <TabBase
    :text="text"
    :size="size"
    :icon="icon"
    :iconTone="iconTone"
    :disabled="disabled"
    :class="[
      style.tabStyle,
      style[variant],
      active ? style.active : null,
      disabled ? style.disabled : null
    ]"
  >
    <template v-if="$slots.default" #default>
      <slot />
    </template>
  </TabBase>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import TabBase from "@/elements/UI/tabs/TabBase/TabBase.vue";
import style from "./TabStyle.module.scss";

export default defineComponent({
  name: "TabStyle",
  components: {TabBase},
  props: {
    variant: {
      type: String as PropType<TypeTab>,
      default: "subtle"
    },
    icon: {
      type: String,
      default: ""
    },
    iconTone: {
      type: String as PropType<IconTone>,
      default: "accent"
    },
    size: {
      type: String as PropType<Size>,
      default: "M"
    },
    text: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style
    };
  }
});
</script>
